var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundArrowsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.772,
    height: 21.566,
    viewBox: "0 0 23.772 21.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11461",
    "data-name": "Group 11461",
    transform: "translate(-337.547 -689.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16786",
    "data-name": "Path 16786",
    d: "M1575.794,2246.25l-4.519,4.323,4.519,4.224",
    transform: "translate(-1233 -1556)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16789",
    "data-name": "Path 16789",
    d: "M1571.275,2254.8l4.519-4.323-4.519-4.224",
    transform: "translate(-1215.202 -1543.703)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16787",
    "data-name": "Path 16787",
    d: "M1571.668,2250.523h15.816s4.421-.442,5.108,5.649",
    transform: "translate(-1233 -1556)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16788",
    "data-name": "Path 16788",
    d: "M1592.592,2256.165h-15.816s-4.421.442-5.108-5.649",
    transform: "translate(-1232.393 -1549.344)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrowsIcon);
export default __webpack_public_path__ + "static/media/RoundArrowsIcon.0684ed957cbaaea70d402761f016b5ea.svg";
export { ForwardRef as ReactComponent };